// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__cgNRf","imageUploader":"EGiftCard_imageUploader__-FIef"};